import { render, staticRenderFns } from "./AddNewCompanyNow.vue?vue&type=template&id=288f6b5c&scoped=true"
import script from "./AddNewCompanyNow.vue?vue&type=script&lang=js"
export * from "./AddNewCompanyNow.vue?vue&type=script&lang=js"
import style0 from "./AddNewCompanyNow.vue?vue&type=style&index=0&id=288f6b5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288f6b5c",
  null
  
)

export default component.exports